<template>
	<div>
        <div class="box_line">
          <div class="line_item">
            <span class="title">搜索地址</span>
            <el-input  placeholder="请输入要搜索的地址" v-model="searchAddress"></el-input>
          </div>
          <div class="line_item show">
              <div class="btn_box" @click="fnSearchAddress"><span>搜 索</span></div>
              <el-input v-model="lnglat"></el-input>
          </div>
        </div>
		<el-amap class="amap-boxs" :vid="'amap-vues'" :map-style="mapStyle" :events="events" :map-manager="amapManager" :zoom="zoom" :center="center">
			<el-amap-marker :position="center" />
		</el-amap>
	</div>
</template>
<script>
import { AMapManager } from 'vue-amap';
let amapManager = new AMapManager();
export default {
	data() {
		let self = this;
		return {
			amapManager,
            searchAddress: '',
			zoom: 12,
			center: [106.54451,29.402152],// 设置的中心点位置
			mapStyle: 'amap://styles/darkblue',
			lng: '106.54451',
			lat: '29.402152',
            lnglat: '106.54451,29.402152',
            events: {
            	click(e) {
            		const { lng, lat } = e.lnglat
            		self.lng = lng
            		self.lat = lat
                    self.center = [lng,lat]
                    self.lnglat = lng + ',' + lat
                    self.$emit('fnGetLocation',lng,lat)
            	},
            },
		};
	},
    mounted() {
      this.$emit('fnGetLocation',this.lng,this.lat)
    },
	methods: {
        fnSearchAddress(){
            const self = this
            AMap.plugin('AMap.Geolocation', function () {
                var geocoder = new AMap.Geocoder({})
                geocoder.getLocation(self.searchAddress, function (status, result) {
                    if (status === 'complete'&&result.geocodes.length) {
                        const { lng, lat } = result.geocodes[0].location
                        self.lng = lng
                        self.lat = lat
                        self.center = [lng,lat]
                        self.lnglat = lng + ',' + lat
                        self.$emit('fnGetLocation',lng,lat)
                    }else{
                        self.$message.warning('根据地址查询位置失败')
                    }
                });
            })
        },

	}
};
</script>

<style scoped lang="scss">
@import "~@/styles/mixin.scss";
.amap-boxs {
	width: 700px;
	height: 440px;
}
.amap-page-container {
    position: relative;
}
.box_line{
      width: 700px;
      height: 40px;
      line-height: 40px;
      margin-bottom: 10px;
      @include flex-box(space-around,center);
      .line_item{
        width: 340px;
        &.show{
            @include flex-box();
        }
        .title{
          display: inline-block;
          width: 120px;
        }
        >>>.el-input{
            width: 215px;
        }
        >>>.el-input__inner{
            width: 215px;
            height: 30px;
            line-height: 30px;
            padding-left: 15px;
            color: rgba(77, 180, 244, 0.7);
            font-size: 12px;
            border: 0;
            outline:none;
            background-color: rgba(49, 88, 128, 0.4);
            &::-webkit-input-placeholder{
                color: rgba(77, 180, 244, 0.7);
            }
            &::-moz-placeholder{   /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-ms-input-placeholder{  /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }
        .btn_box{
            width: 80px;
            height: 32px;
            margin-top: 4px;
            margin-right: 10px;
            background: url(../../assets/img/btn_bg_bsm.png) no-repeat;
            background-size: 100% 100%;
            color: #FFFFFF;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center,center);
            span{
                margin-top: -5px;
            }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Map/location.vue